import { useEffect } from "react";
const useIntersectionObserver = (ref, callback, options) => {
  useEffect(() => {
    const intersectionObserver = new IntersectionObserver(callback, options);
    if (ref == null ? void 0 : ref.current) {
      intersectionObserver.observe(ref.current);
    }
    return () => {
      if (ref == null ? void 0 : ref.current) {
        intersectionObserver.unobserve(ref.current);
      } else {
        intersectionObserver.disconnect();
      }
    };
  }, [ref, options]);
};
export {
  useIntersectionObserver
};
//# sourceMappingURL=useIntersectionObserver.js.map
